/**
 * Option lists from Angular `transfer-process-list.component.html` transfer / status selects.
 */
export const TRANSFER_PROCESS_NAME_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'Transfer Type' },
  { value: 'transfer_property', label: 'Transfer Property' },
  { value: 'transfer_staff', label: 'Transfer Staff' },
  { value: 'transfer_company', label: 'Transfer Company' },
  { value: 'transfer_resident', label: 'Transfer Resident' },
  { value: 'merge_property', label: 'Merge Property' },
  { value: 'split_property', label: 'Split Property' },
]

/** Angular template: empty + Pending + Completed (only). */
export const TRANSFER_STATUS_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'Status' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Completed', label: 'Completed' },
]
